/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import React, { useEffect, useState } from 'react';
import type { appConfigs, TemplateSummaryProps } from '../types/types';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import Tooltip,  {tooltipClasses } from '@mui/material/Tooltip';
import type { TooltipProps } from '@mui/material/Tooltip';
import { styled } from '@mui/material';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import {  ViewStrokeRounded } from '@hugeicons-pro/core-stroke-rounded';
import TemplatePreview from '../TemplatePreview/TemplatePreview';
import Loader from '../Loader';

export interface PropsType {
  template?: TemplateSummaryProps;
  label: string;
  mode? : string;
}

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} placement="bottom" />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
  [`& .${tooltipClasses.arrow}`]: {
    display: 'none',
  },
}));

  const TemplateSummary = ({ template, label, mode }: PropsType): JSX.Element =>{
  
  const templateData = template;
  const navigate = useNavigate();
  const [previewImageUrl, setPreviewImageUrl] = useState<string>('');
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);

  const storedAppConfig = localStorage.getItem("appConfigs");
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const userData = JSON.parse(localStorage.getItem("user") ?? "{}");
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-unsafe-member-access
    const fullname = `${userData.firstName ?? ""} ${userData.lastName ?? ""}`.trim();
    const [isImageLoaded, setIsImageLoaded] = useState(false);
    const [retryCount, setRetryCount] = useState(0);
    const maxRetries = 5;
    useEffect(() => {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      if (!isImageLoaded && retryCount < maxRetries && previewImageUrl) {
        const timer = setTimeout(() => {
          setRetryCount((prev) => prev + 1);
          // Force reload by changing the image URL slightly (cache buster)
          setPreviewImageUrl((prevUrl) => `${prevUrl?.split('?')[0]}?retry=${Date.now()}`);
        }, 5000); // retry every 5 seconds
    
        return () => clearTimeout(timer);
      }
    }, [retryCount, isImageLoaded, previewImageUrl]);
        
    useEffect(() => {
      setIsImageLoaded(false);
      setRetryCount(0);
    }, [previewImageUrl]);
    
  const detailsArray: any = [
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    { label: 'Template ID', value: templateData?.id },
    { label: 'Template Name', value: templateData?.templateName },
    { label: 'From Email', value: templateData?.fromEmail },
    { label: 'Reply-To Email',  value: templateData?.replyToEmail === "" || templateData?.replyToEmail == null  ? 'N/A' : templateData.replyToEmail },
    { label: 'From Name', value: templateData?.fromName },
    { label: 'Initial Send Subject Line', value: templateData?.subjectLine },
    { label: 'Initial Send Preheader', value: templateData?.preheader },
    { label: 'ResendPreheaders', value: templateData?.resendPreheaders },
    // { label: 'Resend Preheader', value: templateData?.resendPreheader ?? 'N/A' },
  ];
console.log("preoview template", template);
  const handleTemplateOverview = (): void => {
    navigate('/template');
  };
  useEffect(() => {
 let imageUrl: string | null = null;
  
        if (storedAppConfig != null) {
          try {
            const parsedAppConfig = JSON.parse(storedAppConfig) as appConfigs[];
            const storedGuid = mode === "edit" ? template?.templateIdentifier : localStorage.getItem("templateGuid");
            const templateVersion = template?.templateVersion ?? 1;
            const TemplateImagePublicURL = parsedAppConfig.find(
              (item) => item.configName === "TemplateImagePublicURL"
            )?.configValue;
            if (TemplateImagePublicURL !='') {
              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
              imageUrl = `${TemplateImagePublicURL}Template/${storedGuid}/${templateVersion}/Template_Large.png`;
              setPreviewImageUrl(imageUrl);
            }
          } catch (error) {
            console.error("Error parsing appConfig data:", error);
          }
        }
  
  }, [])
  return (
    <div className="bg-white w-full">
      {/* ✅ Success Message with Green Tick */}
      <div className="flex flex-col items-center bg-gray-50 mb-[30px]">
        <svg height="70px" width="70px" viewBox="0 0 32 32" fill="#38b120">
          <path d="M16,0C7.164,0,0,7.164,0,16s7.164,16,16,16s16-7.164,16-16S24.836,0,16,0z M13.52,23.383L6.158,16.02l2.828-2.828l4.533,4.535l9.617-9.617l2.828,2.828L13.52,23.383z" />
        </svg>
        <p className="font-semibold text-muted text-[1.5rem] mt-2" >{label}</p>
      </div>

      {/* ✅ Main Content Section */}
      <div className="flex pb-4">
        {/* ✅ Left Section: Summary */}
        <div className="w-1/2">
                <div className="mb-[25px] w-full relative">
                  <div className="bg-[#f5f5f5] text-center text-[18px] font-semibold rounded-full p-[4px] text-muted w-full">
                    Summary
                  </div>
                </div>

              <div className="">
                {detailsArray.map((item: any, index: any) => {
                  if (item.label !== 'ResendPreheaders') {
                  return (
                  <div key={index} className="flex mb-[15px]">
                    <span className="text-muted font-semibold w-1/2 text-[14px]">
                    {item.label}</span>
                    <BootstrapTooltip title={item.value}><span className="text-muted w-1/2 truncate" >{item.value}</span></BootstrapTooltip>
                  </div>
                )} else {
                  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                    return (
                      item.value && item.value.length > 0 && item.value.map((resend: any, resendIndex: number) => (
                        <React.Fragment key={resendIndex}>
                        <div className="flex mb-[15px]">
                          <span className="text-muted font-semibold w-1/2 text-[14px]">
                            Resend Subject Line {resendIndex + 1}</span>
                          <BootstrapTooltip title={resend.subject}><span className="text-muted w-1/2 truncate" >{resend.subject}</span></BootstrapTooltip>
                        </div>
                        <div key={index} className="flex mb-[15px]">
                          <span className="text-muted font-semibold w-1/2 text-[14px]">
                            Resend Preheader {resendIndex + 1}</span>
                          <BootstrapTooltip title={resend.preheader}><span className="text-muted w-1/2 truncate" >{resend.preheader}</span></BootstrapTooltip>
                        </div>
                        </React.Fragment>
                      )
                      )
                    )
                }
                })}
              </div>
        </div>

        {/* ✅ Right Section: Template Preview */}
        <div className="w-1/2 pl-[20px] flex flex-col items-start">
          <p className="text-16 font-semibold text-muted mb-2">Template Preview</p>
          <div className=" h-[350px] flex items-center justify-center relative w-full border border-[#e6ecf2] rounded-lg">
            
              <img
                src={previewImageUrl}
                alt="Template Preview"
                className="icon-hover"
                onLoad={() => setIsImageLoaded(true)}
                onError={() => {
                  // Only set retry trigger if not maxed out
                  if (retryCount < maxRetries) {
                    setIsImageLoaded(false);
                  }
                }}
                style={{ display: isImageLoaded ? 'block' : 'none', width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
              />
           
            <React.Fragment>
              {!isImageLoaded && (
                <div className="absolute inset-0 flex items-center justify-center bg-white rounded-lg">
                  <Loader />
                </div>
              )}
            </React.Fragment>

            {/* Hover View Icon */}
            <div 
              className={`absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 rounded-lg hover:opacity-100 transition-opacity cursor-pointer`} 
              onClick={() => setIsPreviewModalOpen(true)}
            >
              <HugeiconsIcon
                icon={ViewStrokeRounded}
                size={24}
                color="currentcolor"
                strokeWidth={0.5}
                className="cursor-pointer text-white"
                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                onClick={() => setIsPreviewModalOpen(true)}

              />
            </div>
            <TemplatePreview
              isOpen={isPreviewModalOpen}
              onClose={() => setIsPreviewModalOpen(false)}
              content={template?.templateContent ?? ''}
            />
          </div>

          <div className="text-sm text-gray-700 mt-3">
            <span className="font-semibold text-muted" style={{ fontSize: '14px' }}>Created:</span>
            <span className="font-normal text-muted" style={{ fontSize: '14px' }}> {moment().format('MM/DD/YYYY h:mmA')} <span style={{ fontStyle: "italic" }}> ({fullname})</span></span>
          </div>
        </div>
      </div>

      {/* ✅ Footer Section with Button */}
      
      {/* ✅ Light border section */}
      <div className="mt-2">
        <div className="border-t border-gray-200 opacity-20 mt-4 px-8 py-4 flex justify-end"></div>
      </div>

      {/* ✅ Button section */}
      <div className="pL-6 flex justify-end">
        <Button
          variant="outlined"
          sx={{
            color: '#D6242C',
            border: '1px solid #D6242C',
            borderRadius: '50px',
            fontSize: '14px',
            textTransform: 'none',
            fontFamily: 'Manrope',
            background: '#FAFAFA',
            fontWeight: '600',
            width: '200px',
            '&:hover': {
              border: '1px solid #D6242C',
            },
          }}
          onClick={handleTemplateOverview}
        >
          Template Overview
        </Button>
      </div>
    </div>
  );
};

export default TemplateSummary;
